module.exports = __webpack_public_path__ + "static/media/004-map-location.d1e5fbf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/common/icon/004-map-location.png
// module id = 678
// module chunks = 0